import * as angular from "angular";
import {IHttpService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";

export class AddressesGoogleValidationService {

  constructor(private $http: IHttpService, private splitService: SplitService) {}

  getGoogle(addressToValidate: string) {
    const siteId = this.splitService.getSiteId();
    //https://addressvalidation.googleapis.com/v1:validateAddress?
    // const url =  'https://content-addressvalidation.googleapis.com/v1:validateAddress';
    const url =  `https://content-addressvalidation.googleapis.com/v1:validateAddress`;

    return this.$http.post(url, {
      "address": {
        "regionCode": "US",
        "addressLines": [
          "500 West 2nd Street Austin, TX 78701"
        ]
      }
    }, {
      params: {
        alt: 'json',
        key: 'AIzaSyCjW9Y-4YcOQA9FxLMw1EUjoEohwtfljqU'
      }
    })
      .then((res) => {

      })
      .catch((err) => {

      })
  }
}

angular
  .module('bringoz.admin.addresses')
  .service('addressesGoogleValidationService', AddressesGoogleValidationService);
